import { noTokenHttpClient } from "../utils/httpClient";
import { post } from "../utils/httpClients-methods";
import { API_URL } from "../utils/AppApiUrl";

const ForgotPasswordService = async (baseURL, requestBody) => {
  try {
    const response = await post(
      noTokenHttpClient,
      `${baseURL}${API_URL.forgot_Password_url}`,
      requestBody
    );
    if (response?.status === 200 && response.data) {
      return response.data;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export const changeForgotPassword = async (baseURL, requestBody) => {
  try {
    const response = await post(
      noTokenHttpClient,
      `${baseURL}${API_URL.changeForgotPassword}`,
      requestBody
    );
    if (response?.status === 200 && response.data) {
      return response.data;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export default ForgotPasswordService;
